// extracted by mini-css-extract-plugin
module.exports = {"container":"privacy_container__kvJA3"};